module.exports = __webpack_public_path__ + "img/gq14.7caed5a2.png";